<script>
export default {
  data() {
    return {
      windowHeight: null,
      windowWidth: null,
    };
  },
  methods: {
    windowResized() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if (!!this.eventBus) {
        this.eventBus.$emit("resize", this.windowHeight, this.windowWidth);
      } else {
        this.$emit("resize", this.windowHeight, this.windowWidth);
      }
    },
  },
  created() {
    window.addEventListener("resize", this.windowResized);
    this.windowResized();
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResized);
  },
};
</script>